import React from 'react';
import { MuiThemeProvider } from '@material-ui/core';
import { Provider } from 'react-redux';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { SnackbarProvider } from 'notistack';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import theme from '../themes';
import store from '../store';
import App from '../App';

export default () => (
  <MuiThemeProvider theme={theme}>
    <Provider store={store}>
      <SnackbarProvider>
        <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_V3_KEY}>
          <DndProvider backend={HTML5Backend}>
            <App />
          </DndProvider>
        </GoogleReCaptchaProvider>
      </SnackbarProvider>
    </Provider>
  </MuiThemeProvider>
);
